import { useQuery } from '@apollo/client/react';
import { useCurrentOverviewDate } from '~/calendar/hooks/useCurrentOverviewDate';
import { CurrentUserDocument } from '~/graphql/generated/graphql';
import { useTranslation } from 'react-i18next';
import { SidebarLayoutHeader } from '~/layout/components/sidebar-layout-header/SidebarLayoutHeader';
import { StandardHeader } from '~/layout/components/standard-header/StandardHeader';
import { useRouter } from 'expo-router';
import { format } from 'date-fns';

export interface OverviewHeaderProps {}

const getGreetingKey = (): 'morning' | 'afternoon' | 'evening' => {
  const hour = new Date().getHours();
  if (hour < 12) return 'morning';
  if (hour < 17) return 'afternoon';
  return 'evening';
};

export interface OverviewHeaderBodyProps {
  className?: string;
}

const OverviewHeaderBody = ({ className }: OverviewHeaderBodyProps) => {
  const { t } = useTranslation('calendar');
  const date = useCurrentOverviewDate();
  const { data } = useQuery(CurrentUserDocument);
  const firstName = data?.currentUser?.firstName ?? '';
  const router = useRouter();

  return (
    <StandardHeader
      className={className}
      subtitle={t(`greeting.${getGreetingKey()}`)}
      title={firstName}
    >
      <StandardHeader.Date
        currentDate={date}
        onDateChange={(newDate) => {
          router.replace(`/${format(newDate, 'yyyy-MM-dd')}`);
        }}
      />
    </StandardHeader>
  );
};

export const OverviewHeader = Object.assign(
  ({}: OverviewHeaderProps) => {
    return (
      <SidebarLayoutHeader>
        <OverviewHeaderBody />
      </SidebarLayoutHeader>
    );
  },
  { Body: OverviewHeaderBody },
);
